// biome-ignore lint/style/useImportType: <explanation>
import type { FC } from 'react'
import { useState, useEffect, useCallback } from 'react'
import { Form, Input, notification, Select } from 'antd'
import { Layout } from 'shared/components/layout/Layout'
import { Typography, Modal, RegularButton } from 'fronton-react'
import type { UserInfoResponse } from 'redux/interfaces'
import { useDispatch, useSelector } from 'react-redux'
import { suppliersSelector, userInfoSelector } from 'redux/selectors'
import { useHistory } from 'react-router-dom'
import { ADD_CALENDAR_FORM, MY_CALENDARS } from 'shared/consts'

import './authorization.scss'
import { getSuppliers } from 'redux/actions'
import { debounce, isEmpty } from 'lodash'
import { parseJwt } from 'shared/utils'
import { UnauthorizedDescription } from 'shared/components/Notification/descriptions'

const { Option } = Select

const REACT_APP_AUTH_URL = process.env.REACT_APP_AUTH_URL

export const AuthorizationPage: FC = () => {
    const [modal, setModal] = useState(false)
    const [form] = Form.useForm()
    const userInfo: UserInfoResponse = useSelector(userInfoSelector)
    const accessToken = localStorage.getItem('accessToken')
    const REACT_APP_AUTH_HOST = new URL(
        REACT_APP_AUTH_URL ? REACT_APP_AUTH_URL : 'http://localhost:3002'
    ).host

    useEffect(() => {
        const isEmptyAccessToken = isEmpty(accessToken)
        const { exp, iss } = parseJwt(accessToken)
        const expiresDate = new Date(exp * 1000)
        const currentDate = new Date()
        const isExpiresToken = expiresDate < currentDate

        let issHost = null
        try {
            if (iss) {
                issHost = new URL(iss).host
            }
        } catch (error) {
            console.error('Invalid iss URL:', iss, error)
            issHost = null
        }

        const isWrongIss = issHost !== REACT_APP_AUTH_HOST

        if (isEmptyAccessToken || isExpiresToken || isWrongIss) {
            notification['error']({
                message: 'Ошибка авторизации 401',
                description: <UnauthorizedDescription />,
                duration: 5
            })

            setTimeout(() => {
                if (typeof window !== 'undefined' && window.location.pathname !== '/') {
                    window.location.href = '/'
                }
                localStorage.clear()
            }, 5000)
        }
    }, [accessToken, userInfo])

    const { list } = useSelector(suppliersSelector)
    const [supplier, setSupplier] = useState('')
    const history = useHistory()
    const dispatch = useDispatch()

    const onSearch = debounce((value: string) => {
        dispatch(getSuppliers.request(value))
    }, 1000)

    const handleAddCalendarClick = useCallback(() => {
        localStorage.setItem('supplierId', supplier)

        if (!userInfo.isAdmin) {
            setModal(true)
            return
        }
        history.push(MY_CALENDARS)
    }, [userInfo, supplier])

    const handleChange = (value: string) => {
        setSupplier(value)
    }

    const onModalOk = () => {
        history.push(`${ADD_CALENDAR_FORM}?type=standart`)
    }

    const onModalNo = () => {
        history.push(MY_CALENDARS)
    }

    return (
        <Layout title="Авторизация" userInfo={userInfo}>
            <div className="page-content">
                <div className="supplier-content">
                    <Typography variant="h3" style={{ marginBottom: '10px' }}>
                        {!userInfo.isAdmin && 'Вы успешно прошли авторизацию как поставщик'}
                    </Typography>
                    <Form
                        form={form}
                        // onValuesChange={onFormValuesChange}
                    >
                        <Form.Item>
                            <Input
                                disabled
                                placeholder="input placeholder"
                                value={userInfo.subtitle || 'Admin'}
                            />
                        </Form.Item>
                        <p style={{ fontWeight: 'normal', marginBottom: '10px' }}>
                            {userInfo.isAdmin
                                ? 'Введите отделение поставщика'
                                : 'Для данного поставщика требуется дополнительная информация'}
                        </p>
                        <Form.Item>
                            <Select
                                showSearch={userInfo.isAdmin}
                                style={{ fontWeight: 'normal' }}
                                placeholder="Выберите отделение поставщика"
                                onChange={handleChange}
                                onSearch={onSearch}
                            >
                                {userInfo.isAdmin
                                    ? list.map((el) => (
                                          <Option key={el.supplierId} value={el.supplierId}>
                                              {`${el.supplierId} - ${el.name}`}
                                          </Option>
                                      ))
                                    : userInfo.suppliers?.map((el: string) => (
                                          <Option key={el} value={el}>
                                              {el}
                                          </Option>
                                      ))}
                            </Select>
                        </Form.Item>
                    </Form>
                </div>
                <RegularButton
                    size="m"
                    variant="primary"
                    className="add-calendar-button"
                    disabled={!supplier}
                    onClick={handleAddCalendarClick}
                >
                    Вход в профиль поставщика
                </RegularButton>
            </div>
            <Modal
                size="s"
                key="authoriztionModal"
                className="authorization-modal"
                show={modal}
                closeButton={false}
                onClose={() => setModal(false)}
                overlayType="medium"
            >
                <div className="modal-content">
                    <div className="modal-content-body">
                        Вы готовы осуществлять поставки в период праздничных дней по стандартному
                        графику?
                    </div>
                    <div className="modal-content-actions">
                        <RegularButton
                            size="m"
                            variant="primary"
                            className="modal-content-btn"
                            onClick={onModalOk}
                        >
                            Да, выбрать период праздников
                        </RegularButton>
                        <RegularButton
                            size="m"
                            variant="primary"
                            className="modal-content-btn"
                            onClick={onModalNo}
                        >
                            Нет, заполнить календарь недоступности
                        </RegularButton>
                    </div>
                </div>
            </Modal>
        </Layout>
    )
}
